import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { emailValidator} from "../utils/app-validators";
import Swal from 'sweetalert2'
import { AuthenticationService } from "../services/authentication.service";
import { Router } from "@angular/router";
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  public form: FormGroup;
  error: string;
  public id;
  loading = false;
  public record:any;
  spinnerType = SPINNER.circle;
  public submitted = false;
  showPassword: boolean = false;
  constructor(
    private ngxService: NgxUiLoaderService, public fb: FormBuilder, public authenticationService: AuthenticationService,  public router: Router) { }

  ngOnInit(): void {
    this.record = JSON.parse(localStorage.getItem('requestToken'));
    this.form = this.fb.group({
      otp: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
    this.form.reset();
  }
  get f() { return this.form.controls; }
  public onSubmit(values: Object): void {
    this.submitted = true;
    // stop here if form is invalid
    if (this.form.invalid) {
        return;
    }
    if (this.form.valid) {
      let otp = this.form.get('otp').value
      let password = this.form.get('password').value
      let obj = {otp: otp, password:password, email: this.record.email,requestToken: this.record.requestToken,  role:"Merchant"}
       console.log(obj)
       this.ngxService.start();
      this.authenticationService.changePassword(obj).subscribe(
        (response:any) => {
          this.router.navigate(["/sign-in"]);
          Swal.fire('', 'Password  is changed sucessfully!', 'success')
          this.ngxService.stop();
        },
        error => {
          if (error) {
            Swal.fire('Error',  error.error.message, "error")
          }
          this.ngxService.stop();
        }
      );
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
}
